import type { PropsWithChildren } from 'react';
import type { CmsData } from '../../../interfaces';

const contentWidthStyle = {
  // an unset value means: The tenant theme sets the standard width (1140px, demo 1440px).
  standard: '[--shop-max-width:71.25rem]',
  wide: '[--shop-max-width:90rem]',
  wider: '[--shop-max-width:105rem]',
  widest: '[--shop-max-width:121.25rem]',
  full: '[--shop-max-width:100vw] lg:-ml-1 lg:w-[calc(100%+1rem)]',
} as const;

export const ContentWidth = ({
  children,
  contentWidth,
}: PropsWithChildren<{ contentWidth: CmsData['field_maximum_content_width'] }>) => (
  <div
    className={`shop-content ${(contentWidth && contentWidthStyle[contentWidth]) ?? 'legacy-shop-width'}`}
  >
    {children}
  </div>
);
